import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CompliancePoliciesProvider } from 'app/core/services/requests/provider/compliance-policies/compliance-policies.provider';
import { Item } from 'app/shared/models/policies/policies.model';
import { MediaProvider } from 'app/core/services/requests/provider/media.provider';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class PoliciesService {
  public totalCount: number = 0;
  public totalPages: number = 0;

  constructor(
    private PoliciesProvider: CompliancePoliciesProvider,
    public http: HttpClient,
    private mediaProvider: MediaProvider,
    private ToastrService: ToastrService
  ) {}

  imagemButton = [
    {
      image: '../assets/images/icons/martelo.svg',
      idIcon: 1,
    },
    {
      image: '../assets/images/icons/fotoDoc.svg',
      idIcon: 2,
    },
    {
      image: '../assets/images/icons/balanca.svg',
      idIcon: 3,
    },
    {
      image: '../assets/images/icons/pastaDeArquivos.svg',
      idIcon: 4,
    },
    {
      image: '../assets/images/icons/som.svg',
      idIcon: 5,
    },
    {
      image: '../assets/images/icons/phone.svg',
      idIcon: 6,
    },
    {
      image: '../assets/images/icons/visualizar.svg',
      idIcon: 7,
    },
    {
      image: '../assets/images/icons/genero.svg',
      idIcon: 8,
    },
    {
      image: '../assets/images/icons/config.svg',
      idIcon: 9,
    },
    {
      image: '../assets/images/icons/arroba.svg',
      idIcon: 10,
    },
    {
      image: '../assets/images/icons/cavalo.svg',
      idIcon: 11,
    },
    {
      image: '../assets/images/icons/telefone.svg',
      idIcon: 12,
    },
    {
      image: '../assets/images/icons/direcao.svg',
      idIcon: 13,
    },
    {
      image: '../assets/images/icons/internet.svg',
      idIcon: 14,
    },
  ];

  async getMidia(urlMidia: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.mediaProvider
        .getMidia(urlMidia)
        .getBinary()
        .subscribe(
          res => {
            resolve(res);
          },
          err => {
            reject(err);
          }
        );
    });
  }

  getPolicies(params?: any): Promise<Item[]> {
    let limit = params.limit != null ? params.limit : 2;
    let page = params.page != null ? params.page : 1;
    let filtro = params.filtro != null ? params.filtro : null;
    let ordenacao = params.ordenacao != null ? params.ordenacao : null;
    let publicado = params.publicado != null ? params.publicado : null;

    return new Promise((resolve, reject) => {
      this.PoliciesProvider.list()
        .getListObj({
          Limit: limit,
          CountTotal: 'true',
          Page: page,
          Filtro: filtro,
          Ordenacao: ordenacao,
          Publicado: publicado,
        })
        .subscribe(
          dataPolicies => {
            resolve(dataPolicies);
          },
          err => {
            reject(err);
          }
        );
    });
  }

  getPoliciesId(id: number): Promise<Item[]> {
    return new Promise((resolve, reject) => {
      this.PoliciesProvider.getId()
        .getById(id)
        .subscribe(
          dataPolicie => {
            resolve(dataPolicie);
          },
          err => {
            reject(err);
          }
        );
    });
  }

  deletePolices(id: number): Promise<Item> {
    return new Promise((resolve, reject) => {
      this.PoliciesProvider.delete()
        .delete(id)
        .subscribe(
          res => {
            this.ToastrService.success('A política foi deletada com sucesso!');
            resolve(res);
          },
          err => {
            this.ToastrService.error(
              `Não foi possível deletar a política ${err.message}`
            );
            reject(err);
          }
        );
    });
  }

  updatePolices(id: number, bodyPut: Item): Promise<Item> {
    return new Promise((resolve, reject) => {
      this.PoliciesProvider.update()
        .put(id, bodyPut)
        .subscribe(
          res => {
            this.ToastrService.success(
              'A política foi atualizada com sucesso!'
            );
            resolve(res);
          },
          err => {
            this.ToastrService.error(
              `Não foi possível atualizar a política ${err.message}`
            );
            reject(err);
          }
        );
    });
  }

  postPolices(body: Object): Promise<Item> {
    return new Promise((resolve, reject) => {
      this.PoliciesProvider.create()
        .post(body)
        .subscribe(
          res => {
            this.ToastrService.success(
              'A política foi cadastrada com sucesso!'
            );
            resolve(res);
          },
          err => {
            this.ToastrService.error(
              `Não foi possível criar a política ${err.message}`
            );
            reject(err);
          }
        );
    });
  }
}

